export default __webpack_public_path__ + "static/media/photo--sm--93.66919300.jpg";